import store from "@/store";

export function screenWidth() {
  return store.getters.SCREEN_WIDTH
    ? store.getters.SCREEN_WIDTH
    : window.innerWidth;
}
